import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {scopes, resources} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {Container, Card, Grid, Button, Icon, Input} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {AccessoriesSummaryTable} from './accessoriesSummaryTable';
import {hasAccessPermission} from '../../../common/permissions/validations';
import fscreen from 'fscreen';

const {
  navigateTo,
  fetchAccessoriesRequestsSummary,
} = Actions;

const Index = () => {
  const permissions = useSelector((state) => state.session.permissions);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const loading = useSelector((state) => state.accessoriesRequestsSummary.loading);
  const [accessoryFilter, setAccessoryFilter] = useState('');
  const accessoriesRequestsSummary = useSelector((state) => state.accessoriesRequestsSummary.list);
  const dispatch = useDispatch();

  const handler = () => {
    if (!fscreen.fullscreenElement) {
      setIsFullScreen(false);
    }
  };

  const changeFullScreenListener = () => {
    if (fscreen.fullscreenEnabled) {
      fscreen.addEventListener('fullscreenchange', handler.bind(this), false);
    }
  };

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.AccessoriesRequestSummary, scopes.See) &&
      !hasAccessPermission(permissions, resources.AccessoriesRequestSummary, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    changeFullScreenListener();
    dispatch(fetchAccessoriesRequestsSummary());
  }, [dispatch]);

  const toggleFullScreen = () => {
    if (!fscreen.fullscreenElement) {
      fscreen.requestFullscreen(document.documentElement);
      setIsFullScreen(true);
    } else {
      fscreen.exitFullscreen();
      setIsFullScreen(false);
    }
  };
  
  const handleAccessoryFilter = (e, value) => {
    e.preventDefault();
    setAccessoryFilter(value);
    if (!value) {
      dispatch(fetchAccessoriesRequestsSummary());
    }
  };

  const handleSearchByRequest = (e) => {
    e.preventDefault();
    dispatch(fetchAccessoriesRequestsSummary({'accessory': accessoryFilter}));
  };

  const icon = isFullScreen ? 'compress' : 'expand';

  return (
    <Container fluid>
      <Card raised fluid>
        <div className='title-bar'>
          <Grid columns={2} stackable>
            <Grid.Row>
              <Grid.Column>
                <div className='title'>
                  <h2>Control de pedidos de accesorios - Resumen por accesorios</h2>
                </div>
              </Grid.Column>
              <Grid.Column textAlign='right'>
                <Icon link name={icon} size='big'
                  onClick={toggleFullScreen.bind(this)} />
                <Link to={paths.AccessoriesRequestManagement}>
                  <Button primary>Ir a Control de pedidos</Button>
                </Link>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Card>
      <Card raised fluid>
        <Grid columns={1} padded textAlign='left'>
          <Grid.Row>
            <Grid.Column>
              <div className='flex middle'>
                <h3 style={{'margin': '0', 'paddingRight': '5px'}}>Accesorio: </h3>
                <Input placeholder='PFA1000' value={accessoryFilter.request}
                  onChange={(e, input) => handleAccessoryFilter(e, input.value)}></Input>
                <Icon name='search' size='big' link onClick={(e) => handleSearchByRequest(e)} />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <AccessoriesSummaryTable loading={loading} accessoriesSummaryList={accessoriesRequestsSummary} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    </Container>
  );
};

export default Index;
